<label
  class="flex h-(--ig-editor-field-height,2.33em) w-full min-w-0 items-center gap-2.5 overflow-hidden rounded-(--ig-editor-field-radius,6px) bg-(--ig-editor-field-bg,#2b2e32) px-2 text-sm"
  [class.cursor-pointer]="!disabled()"
  [class.cursor-default]="disabled()"
  [class.opacity-60]="disabled()">
  <input type="checkbox" class="sr-only" [checked]="checked()" [disabled]="disabled()" (change)="onChange($event)" />

  <span
    class="flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border [&_mat-icon]:text-white!"
    [class.border-white]="!checked()"
    [class.border-(--ig-editor-action-color,#3678fc)]="checked()"
    [class.bg-(--ig-editor-action-color,#3678fc)]="checked()"
    aria-hidden="true">
    @if (checked()) {
      <mat-icon class="size-3! text-white!" svgIcon="check"></mat-icon>
    }
  </span>

  <span
    class="min-w-0 overflow-hidden text-xs text-ellipsis whitespace-nowrap text-(--ig-editor-text-color,#ffffff)/90">
    {{ label() }}
  </span>
</label>
